import { useEffect, useState } from 'react'

import { useGetList } from 'react-admin'
import {
  ArtworkApiDTO,
  BeneficiaryApiDTO,
  CompilationApiDTO,
} from '../../codegen/generated/Api.schemas'
import { CompilationStructure } from '../../types/Compilations'
import { CompilationItem } from './CompilationItem'

type CompilationMainArtworkProps = {
  compilation?: CompilationApiDTO
  onUpdate: (mainArtwork: ArtworkApiDTO | undefined) => void
}

export const CompilationMainArtwork = ({ compilation, onUpdate }: CompilationMainArtworkProps) => {
  const [mainArtworkCompilation, setMainArtworkCompilation] = useState<CompilationStructure>({
    id: 'mainArtwork',
    beneficiary: compilation?.mainArtwork?.product?.beneficiary,
    product: compilation?.mainArtwork?.product,
    artwork: compilation?.mainArtwork,
  })
  const beneficiariesQuery = useGetList<BeneficiaryApiDTO>('beneficiaries', {
    sort: { field: 'name', order: 'ASC' },
    pagination: { page: 1, perPage: 1000 },
  })

  useEffect(() => {
    onUpdate(mainArtworkCompilation.artwork)
  }, [mainArtworkCompilation.artwork])

  return (
    <>
      <CompilationItem
        compilationStructure={mainArtworkCompilation}
        beneficiaries={beneficiariesQuery.data ?? []}
        onUpdate={setMainArtworkCompilation}
      />
    </>
  )
}
